
<div class="px-3">

  <page-title 
      icon="money-bill"
      title="Http Payment Gateway Requests" 
      description="Analyze the data of http payment gateway requests of a creditor">
  </page-title>

<div class="mt-4">
    <creditor-autocomplete (onSelect)="onSelectCreditor($event)"></creditor-autocomplete>       
       
    <div class="mt-5 flex gap-2" >
        <div class="p-float-label">
            <p-calendar [(ngModel)]="fromDate"
                        inputId="fromDate"
                        dateFormat="mm/dd/yy"
                        showIcon="true"
                        [showButtonBar]="true">
            </p-calendar>
            <label for="fromDate">From Date</label>
        </div>
        
        <div class="p-float-label">
            <p-calendar [(ngModel)]="toDate"
                        inputId="toDate"
                        dateFormat="mm/dd/yy"
                        showIcon="true"
                        [showButtonBar]="true">
             </p-calendar>
             <label for="toDate">To Date</label>
        </div>
    </div>

    <div class="flex justify-content-end gap-2" style="padding-top: 4px;">
        <remitter-button
                 label="Get"
                 icon='play'
                 severity="primary"
                 (click)="getReport()"
                    />
         <remitter-button
                    label="Export"
                    icon='file-export'
                    severity="secondary"
                    (click)="exportReport()"
                    />
          
        </div>
    </div>

    <div class="mt-4 pt-2 px-3">

       <div 
            *ngIf="!hasTableData && hasClickedSearch"
            style="text-align:center; margin-top:9rem; color: #336699; font-size: 1rem;">
                🚫 No records found for {{ selectedCreditorCompanyName }}
        </div>
        <p-table 
            *ngIf="hasTableData"
            [value]="reportData" 
            [paginator]="true" 
            [rows]="25" 
            [tableStyle]="{ 'min-width': '50rem' }" 
            [rowsPerPageOptions]="[25, 100]">
            <ng-template pTemplate="header">
                <tr class="text-xs">
                    <th>Transaction Correlation Id</th>
                    <th>Account Invoice Id</th>
                    <th>Payment Type</th>  
                    <th *ngIf="hasRequestResponse">Raw Request</th>
                    <th *ngIf="hasRequestResponse">Raw Response</th>
                    <th>Created On</th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr class="text-xs">
                    <td>{{ report.transactionCorrelationId }}</td>
                    <td>{{ report.invoiceNumber }}</td>
                    <td>{{ report.paymentType }}</td>                
                    <td *ngIf="hasRequestResponse">
                        <span class="ellipsis">
                            {{ report.rawRequest }}
                        </span>
                    </td>
                    <td *ngIf="hasRequestResponse">
                        <span class="ellipsis">
                            {{ report.rawResponse }}
                        </span>                        
                    </td>
                    <td>{{ report.createdOn | date: 'MMMM d, y' }}</td>

                </tr>
            </ng-template>
        </p-table>

    </div>
</div>
